// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"79":"release-notes","277":"mfp","536":"new","986":"regions"}[chunkId] + "." + {"79":"c239ccc5","277":"865d43fa","536":"db379c11","986":"421bcf9a"}[chunkId] + ".chunk.css";
};